module.exports = __webpack_public_path__ + "img/apple-pay.8040ea69.svg";